import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { DoseInfo } from '~/components/InfoTooltip/DoseInfo';
import { DoseData } from '~/state/atoms/dose/doseAtoms';

export default function DoseTitle({ dose }: { dose?: DoseData }) {
    return (
        <Box
            display="flex"
            gap={0.5}
            alignItems="center"
            sx={(theme) => ({
                color: theme.palette.primary.main,
            })}
        >
            <Typography fontSize={12}>
                <FormattedMessage id="dose" />
            </Typography>
            {dose && <DoseInfo dose={dose} />}
        </Box>
    );
}
